import { render, staticRenderFns } from "./TransporterTransferHistoryModal.vue?vue&type=template&id=6a158ff7&scoped=true&"
import script from "./TransporterTransferHistoryModal.vue?vue&type=script&lang=js&"
export * from "./TransporterTransferHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./TransporterTransferHistoryModal.vue?vue&type=style&index=0&id=6a158ff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a158ff7",
  null
  
)

export default component.exports